import React from "react";
import { Box, Typography, CircularProgress, Stack } from "@mui/material";
import { SupportAgent } from "@mui/icons-material";
import {
  bgGradient,
  iconGradient,
  iconShadow,
  MESSAGES,
} from "../../constants/consts";

export default function SplashScreen() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: bgGradient,
        position: "relative",
        overflow: "hidden",
        // Login'deki gibi dekoratif daireler
        "&::before": {
          content: '""',
          position: "absolute",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.10)",
          top: -100,
          right: -100,
          animation: "float 6s ease-in-out infinite",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
          bottom: -80,
          left: -80,
          animation: "float 8s ease-in-out infinite reverse",
        },
        "@keyframes float": {
          "0%, 100%": { transform: "translateY(0)" },
          "50%": { transform: "translateY(-20px)" },
        },
        "@keyframes pulse": {
          "0%, 100%": { transform: "scale(1)", opacity: 1 },
          "50%": { transform: "scale(1.05)", opacity: 0.9 },
        },
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "translateY(10px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      <Stack
        alignItems="center"
        spacing={3}
        sx={{
          position: "relative",
          zIndex: 1,
          animation: "fadeIn 0.6s ease-out",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            background: iconGradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: iconShadow,
            animation: "pulse 2s ease-in-out infinite",
          }}
        >
          <SupportAgent sx={{ color: "#fff", fontSize: 48 }} />
        </Box>

        {/* Marka */}
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            fontWeight={800}
            sx={{ color: "#fff", letterSpacing: 1 }}
          >
            {MESSAGES.SPLASH_BRAND}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "rgba(255,255,255,0.85)", letterSpacing: 2 }}
          >
            {MESSAGES.SPLASH_TAGLINE}
          </Typography>
        </Box>

        {/* Yükleniyor */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <CircularProgress size={28} sx={{ color: "#fff" }} />
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.75)", letterSpacing: 1 }}
          >
            {MESSAGES.SPLASH_LOADING}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
